import { useFadeIn } from "../../hooks/useFadeIn";
import { SectionHeader } from "../layout/SectionHeader";
import { projects } from "../../data/projectsData";
import type { Project } from "../../data/projectsData";

const hirestationImg = require("../../assets/hirestation.png");
const dirgahyuImg    = require("../../assets/dirgahyu.PNG");
const purlieuImg     = require("../../assets/purlieu.PNG");
const baatcheethImg  = require("../../assets/vaatcheeth.png");

const projectImages: Record<Project["slug"], string> = {
  hirestation: hirestationImg,
  dirgahyu:    dirgahyuImg,
  purlieu:     purlieuImg,
  baatcheeth:  baatcheethImg,
};

const LinkIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.72" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

const GhIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 .5a12 12 0 0 0-3.79 23.4c.6.11.82-.26.82-.58v-2c-3.34.73-4.04-1.61-4.04-1.61-.55-1.39-1.34-1.76-1.34-1.76-1.09-.74.08-.73.08-.73 1.21.09 1.85 1.24 1.85 1.24 1.07 1.83 2.81 1.3 3.5.99.11-.78.42-1.3.76-1.6-2.66-.3-5.47-1.33-5.47-5.93 0-1.31.47-2.38 1.24-3.22-.13-.31-.54-1.55.12-3.23 0 0 1.01-.32 3.3 1.23a11.4 11.4 0 0 1 6 0c2.29-1.55 3.3-1.23 3.3-1.23.66 1.68.25 2.92.12 3.23.77.84 1.24 1.91 1.24 3.22 0 4.61-2.81 5.62-5.49 5.92.43.37.81 1.1.81 2.22v3.29c0 .32.22.7.83.58A12 12 0 0 0 12 .5z"/>
  </svg>
);

export const Projects = () => {
  const ref = useFadeIn<HTMLElement>();
  return (
    <section ref={ref} className="projects reveal" id="projects">
      <div className="container">
        <SectionHeader num="04" command="> ls ./projects" caption="Selected work." />
        <div className="projects__grid">
          {projects.map((p) => (
            <article className="projCard" key={p.slug}>
              <header className="projCard__chrome">
                <span className="dots dots--sm" aria-hidden="true">
                  <span style={{ background: "#ff5f56" }} />
                  <span style={{ background: "#ffbd2e" }} />
                  <span style={{ background: "#27c93f" }} />
                </span>
                <span className="projCard__url">
                  <span className="dot dot--green" aria-hidden="true" /> {p.domain}
                </span>
              </header>

              <div className="projCard__shot">
                <img
                  src={projectImages[p.slug]}
                  alt={`${p.title} screenshot`}
                  className="projCard__img"
                />
              </div>

              <div className="projCard__body">
                <div className="projCard__row">
                  <h3 className="projCard__title">
                    <span className="projCard__num">{p.num}</span>
                    <span className="projCard__path">
                      <span className="projCard__prefix">./</span>{p.title.toLowerCase()}
                    </span>
                  </h3>
                  <span className="projCard__meta">
                    <span className="year">{p.year}</span> ·{" "}
                    <span className="tag">{p.tag.toLowerCase()}</span>
                  </span>
                </div>

                <p className="projCard__desc">
                  <span className="cmt">{"// "}</span>
                  {p.description}
                </p>

                <ul className="projCard__pills">
                  {p.stack.map((s) => <li key={s}>{s}</li>)}
                </ul>

                {(p.liveUrl || p.repoUrl) && (
                  <footer className="projCard__foot">
                    {p.liveUrl && (
                      <a href={p.liveUrl} target="_blank" rel="noreferrer" className="link link--accent">
                        <LinkIcon /> live demo
                      </a>
                    )}
                    {p.repoUrl && (
                      <a href={p.repoUrl} target="_blank" rel="noreferrer" className="link link--ink">
                        <GhIcon /> GH source
                      </a>
                    )}
                  </footer>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
